import React from 'react';
import DashboardShell from '../../../layouts/DashboardShell';
import { clientSideLinks } from '../clientRoutes';
import ChangePasswordSection from '../../../shared/components/auth/ChangePasswordSection';
import CardIcon from '../../../shared/components/icons/CardIcon';

function ClientSettingsPage() {
  return (
    <DashboardShell role="CLIENT" sideLinks={clientSideLinks}>
      <div className="rounded-3xl bg-white p-6 shadow-sm">
        <h1 className="flex items-center gap-3 text-2xl font-bold text-navy"><CardIcon name="settings" className="h-6 w-6" />Settings</h1>
        <p className="mt-2 text-sm text-slate-600">Update account and notification preferences.</p>
      </div>
      <ChangePasswordSection />
    </DashboardShell>
  );
}

export default ClientSettingsPage;
